import React from 'react'

const Team = () => {
  return (
    <div className="container-fluid team pb-5">
        <div className="container pb-5">
            <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth:'800px'}}>
                <h4 className="text-uppercase text-primary">Our Team</h4>
                <h1 className="display-3 text-capitalize mb-3">Meet Our Wonderful Team of Stewards</h1>
            </div>

            <div style={{paddingBottom:'10px'}} className="row g-4 d-flex justify-content-center align-items-center bg-light">
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="team-item p-4">
                        <div className="team-inner rounded">
                            <div className="team-img">
                                <img src="img/dr-michael-1.jpg" className="img-fluid rounded-top w-100" alt="Dr. Michael Adusei-Nsowah" />
                                <div className="team-share">
                                    <a className="btn btn-secondary btn-md-square rounded-pill text-white mx-1" href="#"><i className="fas fa-share-alt"></i></a>
                                </div>
                                <div className="team-icon rounded-pill py-2 px-2">
                                    <a className="btn btn-secondary btn-sm-square rounded-pill mx-1" href="#"><i className="fab fa-facebook-f"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-twitter"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-linkedin-in"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            <div className="bg-light rounded-bottom text-center py-4">
                                <h4 className="mb-3">Dr. Michael Adusei-Nsowah</h4>
                                <p className="mb-0">Managing Director</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="row g-4">
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="team-item p-4">
                        <div className="team-inner rounded">
                            <div className="team-img">
                                <img src="img/madam.jpg" className="img-fluid rounded-top w-100" alt="Akua Benewaa Amo" />
                                <div className="team-share">
                                    <a className="btn btn-secondary btn-md-square rounded-pill text-white mx-1" href="#"><i className="fas fa-share-alt"></i></a>
                                </div>
                                <div className="team-icon rounded-pill py-2 px-2">
                                    <a className="btn btn-secondary btn-sm-square rounded-pill mx-1" href="#"><i className="fab fa-facebook-f"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-twitter"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-linkedin-in"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            <div className="bg-light rounded-bottom text-center py-4">
                                <h4 className="mb-3">Akua Benewaa Amo</h4>
                                <p className="mb-0">Head - Finance</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.4s">
                    <div className="team-item p-4">
                        <div className="team-inner rounded">
                            <div className="team-img">
                                <img src="img/fred.jpg" className="img-fluid rounded-top w-100" alt="Fred Adusei-Nsowah" />
                                <div className="team-share">
                                    <a className="btn btn-secondary btn-md-square rounded-pill text-white mx-1" href="#"><i className="fas fa-share-alt"></i></a>
                                </div>
                                <div className="team-icon rounded-pill py-2 px-2">
                                    <a className="btn btn-secondary btn-sm-square rounded-pill mx-1" href="#"><i className="fab fa-facebook-f"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-twitter"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-linkedin-in"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            <div className="bg-light rounded-bottom text-center py-4">
                                <h4 className="mb-3">Fred Adusei-Nsowah (PhD)</h4>
                                <p className="mb-0">Programs Lead</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.6s">
                    <div className="team-item p-4">
                        <div className="team-inner rounded">
                            <div className="team-img">
                                <img src="img/kingsley.jpeg" className="img-fluid rounded-top w-100" alt="Kingsley Adisu" />
                                <div className="team-share">
                                    <a className="btn btn-secondary btn-md-square rounded-pill text-white mx-1" href="#"><i className="fas fa-share-alt"></i></a>
                                </div>
                                <div className="team-icon rounded-pill py-2 px-2">
                                    <a className="btn btn-secondary btn-sm-square rounded-pill mx-1" href="#"><i className="fab fa-facebook-f"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-twitter"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-linkedin-in"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            <div className="bg-light rounded-bottom text-center py-4">
                                <h4 className="mb-3">Kingsley Adisu</h4>
                                <p className="mb-0">Sustainability Lead</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.8s">
                    <div className="team-item p-4">
                        <div className="team-inner rounded">
                            <div className="team-img">
                                <img src="img/samuel-afari.jpg" className="img-fluid rounded-top w-100" alt="Samuel Andy Afari" />
                                <div className="team-share">
                                    <a className="btn btn-secondary btn-md-square rounded-pill text-white mx-1" href="#"><i className="fas fa-share-alt"></i></a>
                                </div>
                                <div className="team-icon rounded-pill py-2 px-2">
                                    <a className="btn btn-secondary btn-sm-square rounded-pill mx-1" href="#"><i className="fab fa-facebook-f"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-twitter"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-linkedin-in"></i></a>
                                    <a className="btn btn-secondary btn-sm-square rounded-pill me-1" href="#"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            <div className="bg-light rounded-bottom text-center py-4">
                                <h4 className="mb-3">Samuel Andy Afari</h4>
                                <p className="mb-0">Head - IT &amp; Responsible AI</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Team